"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("./components");
var _LoadingContentSwitch = _interopRequireDefault(require("../LoadingContentSwitch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SaveToFiles = _ref => {
  let {
    isQrp,
    onChange,
    checked = false,
    saveAsNewFile: initialSaveAsNewFile = false,
    projectId,
    folderUrn: initialFolderUrn
  } = _ref;
  const [saveOptions, setSaveOptions] = (0, _react.useState)({
    checked,
    saveAsNewFile: initialSaveAsNewFile,
    folderUrn: initialFolderUrn
  });
  (0, _react.useEffect)(() => onChange(saveOptions), [JSON.stringify(saveOptions)]);
  const shouldShowFolderSelector = () => !isQrp || saveOptions.checked;
  const handleStateChange = function () {
    let newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return setSaveOptions({
      ...saveOptions,
      ...newState
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_LoadingContentSwitch.default, {
      showContent: false
    })
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, {
    $isQrp: isQrp
  }, /*#__PURE__*/_react.default.createElement(StyledSaveToggle, {
    isQrp: isQrp,
    checked: saveOptions.checked,
    onChange: handleStateChange
  }), shouldShowFolderSelector() && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.FolderSelector, {
    disabled: !saveOptions.checked,
    onChange: handleStateChange,
    projectId: projectId,
    folderUrn: initialFolderUrn
  }), /*#__PURE__*/_react.default.createElement(_components.SaveOptions, {
    disabled: !saveOptions.checked,
    isQrp: isQrp,
    saveAsNewFile: saveOptions.saveAsNewFile,
    onChange: handleStateChange
  }))));
};
const StyledContainer = _styledComponents.default.div`
  display: flex;
  gap: 16px;
  ${_ref2 => {
  let {
    $isQrp
  } = _ref2;
  return $isQrp ? 'flex-direction: column;' : 'align-items: start;';
}}
`;
const StyledSaveToggle = (0, _styledComponents.default)(_components.SaveToggle)`
  ${_ref3 => {
  let {
    isQrp
  } = _ref3;
  return !isQrp && 'padding-top: 8px;';
}}
`;
SaveToFiles.propTypes = {
  isQrp: _propTypes.default.bool.isRequired,
  projectId: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  checked: _propTypes.default.bool,
  saveAsNewFile: _propTypes.default.bool,
  folderUrn: _propTypes.default.string
};
var _default = exports.default = SaveToFiles;